import { render, staticRenderFns } from "./newAddContest.vue?vue&type=template&id=4fb2b9a1&scoped=true"
import script from "./newAddContest.vue?vue&type=script&lang=js"
export * from "./newAddContest.vue?vue&type=script&lang=js"
import style0 from "./newAddContest.vue?vue&type=style&index=0&id=4fb2b9a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb2b9a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb2b9a1')) {
      api.createRecord('4fb2b9a1', component.options)
    } else {
      api.reload('4fb2b9a1', component.options)
    }
    module.hot.accept("./newAddContest.vue?vue&type=template&id=4fb2b9a1&scoped=true", function () {
      api.rerender('4fb2b9a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operation/newAddContest.vue"
export default component.exports